const cmip7ProjectionCatalog = {
    schema_version: 1,
    phase: 'CMIP7',
    updated: null,
    curated_scenarios: [
        { id: 'esm-hist', label: 'ESM Historical' },
        { id: 'esm-scen7-vl', label: 'ESM Very Low' },
        { id: 'esm-scen7-h', label: 'ESM High' },
    ],
    variables: {
        tas: {
            label: 'Near-surface air temperature', units: '°C', products: [],
            legend: { breaks: [18, 22, 25, 28, 31, 34], colors: ['#193b63', '#287da6', '#75c5c7', '#f4e285', '#e98742', '#b84035'] },
        },
        pr: {
            label: 'Precipitation rate', units: 'mm day⁻¹', products: [],
            legend: { breaks: [0, 1, 3, 6, 10, 16], colors: ['#f7fbff', '#b9e0ee', '#65bdd1', '#3485b5', '#514b9c', '#7c287d'] },
        },
        psl: {
            label: 'Sea-level pressure', units: 'hPa', products: [],
            legend: { breaks: [980, 995, 1005, 1015, 1025, 1040], colors: ['#513a84', '#3777a8', '#88c8ca', '#f1dc82', '#dc7a44', '#9e3a42'] },
        },
        ps: {
            label: 'Surface air pressure', units: 'hPa', products: [],
            legend: { breaks: [980, 995, 1005, 1015, 1025, 1040], colors: ['#513a84', '#3777a8', '#88c8ca', '#f1dc82', '#dc7a44', '#9e3a42'] },
        },
        sfcWind: {
            label: 'Near-surface wind speed', units: 'm s⁻¹', products: [],
            legend: { breaks: [0, 3, 6, 10, 15, 22], colors: ['#e8f2f3', '#9bd4d7', '#54b7bc', '#e6d465', '#e98b3b', '#bd4540'] },
        },
    },
};

export default cmip7ProjectionCatalog;
